import { render, staticRenderFns } from "./ProductForm.pug?vue&type=template&id=4d3bcd3b&scoped=true&lang=pug&"
import script from "./ProductForm.js?vue&type=script&lang=js&"
export * from "./ProductForm.js?vue&type=script&lang=js&"
import style0 from "./ProductForm.sass?vue&type=style&index=0&id=4d3bcd3b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3bcd3b",
  null
  
)

component.options.__file = "ProductForm.vue"
export default component.exports